<app-resources-table></app-resources-table>
